export default {"src":"https://assets.eu.daedalus.fih.io/_next/static/media/card.4db0d4f7.svg","height":14,"width":16,"blurWidth":0,"blurHeight":0};